const DisplayBoolean = ({ value }) => {
    switch (value) {
        case true:
            return 'Ja';
        case false:
            return 'Nej';
        default:
            return null;
    }
};

export default DisplayBoolean;
